import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const NotificationQuerySchema = z.object({
    unreadOnly: z
        .string()
        .optional()
        .transform((v) => v === 'true')
        .openapi({
        description: 'Filter to unread notifications only',
        example: 'true',
    }),
    limit: z
        .string()
        .optional()
        .transform((v) => (v ? parseInt(v, 10) : undefined))
        .openapi({
        description: 'Maximum number of notifications to return',
        example: '20',
    }),
});
export const NotificationIdParamSchema = z.object({
    notificationId: z.string().uuid().openapi({
        description: 'Notification UUID',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
export const NotificationSchema = z
    .object({
    id: z.string().uuid().openapi({
        description: 'Unique identifier for the notification',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
    userId: z.string().uuid().openapi({
        description: 'UUID of the user this notification belongs to',
        example: '660e8400-e29b-41d4-a716-446655440001',
    }),
    type: z.string().openapi({
        description: 'Notification type identifier',
        example: 'course_generation_complete',
    }),
    title: z.string().openapi({
        description: 'Short display title for the notification',
        example: 'Course generation complete',
    }),
    body: z.string().nullable().openapi({
        description: 'Optional detailed body text of the notification',
        example: 'Your course "Intro to TypeScript" has been generated successfully.',
    }),
    link: z.string().nullable().openapi({
        description: 'Optional URL or route path the notification links to',
        example: '/admin/courses/550e8400-e29b-41d4-a716-446655440000',
    }),
    read: z.boolean().openapi({
        description: 'Whether the notification has been read by the user',
        example: false,
    }),
    metadata: z.unknown().nullable().openapi({
        description: 'Optional arbitrary metadata associated with the notification',
    }),
    createdAt: z.string().datetime().openapi({
        description: 'ISO 8601 timestamp when the notification was created',
        example: '2026-02-27T10:00:00.000Z',
    }),
})
    .openapi('Notification');
export const NotificationsResponseSchema = z
    .object({
    notifications: z.array(NotificationSchema),
    unreadCount: z.number().openapi({
        description: 'Number of unread notifications for the user',
        example: 3,
    }),
})
    .openapi('NotificationsResponse');
//# sourceMappingURL=notification.schema.js.map